import  * as React from "react";
import {ISponsorDetailsProps} from "./ISponsorDetailsProps";
import { observer } from "mobx-react";


@observer
export class SponsorDetails extends React.Component<ISponsorDetailsProps>{
    constructor(props: ISponsorDetailsProps) {
        super(props, undefined);
    }

    render() {
        const sponsors = this.props.sponsors.map((sponsor) => {
            let logoWrapper =
                <div className="logo-wrapper col-xs-3 col-print-3">
                    {
                        sponsor.kind === "Main" ?
                        <a className="logo-box" { ...(sponsor.link !== "" && { href : sponsor.link }) } target="_blank">
                            {sponsor.logo !== "" && <img src={ sponsor.logo } alt=""/>}
                        </a>
                        :<span className="logo-box">
                            {sponsor.logo !== "" && <img src={sponsor.logo} alt="" />}
                        </span>
                    }
                </div>;

            let headLineDescription =
                <div className="headline-and-description col-xs-9 col-print-9">
                    { sponsor.headline !== "" ? <h3>{ sponsor.headline }</h3> : "" }
                    { sponsor.description !== "" ? <p className="limited-text-lines"> {sponsor.description} </p> : "" }
                </div>;
            return <div key={sponsor.id}>
                       {logoWrapper}
                       {headLineDescription}
                   </div>;
        });
        return <div className={'SponsorDetails ' + (sponsors.length > 0 ? "details row details-padding" : "details row")}>
                   {sponsors}
               </div>;

    }
}
